module.exports = __webpack_public_path__ + "f5546e4bbf75d7db7cbe5b1b75aad803.png";